import { Injectable } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import allLocales from '@fullcalendar/core/locales-all';
import * as moment from 'moment';
import { RolType } from '../../models/types/rol.types';
import { EventType } from './../../../shared/models/types/event.types';
import { AuthService } from './../security/auth.service';
import { TranslatorService } from './../utils/translator.service';

@Injectable()
export class CalendarDataService {

  rolType = new RolType();

  constructor(private readonly translateService: TranslatorService, private readonly authService: AuthService) {

  }

  getCalendar(calendar: FullCalendarComponent, rol: string, inCall?: boolean, isNotPlanning?: boolean): any {
    const calendarCommon = this.getCalendarCommon(calendar);

    if (isNotPlanning) {
      return this.getCalendarOfUserWeekMode(calendarCommon);
    }
    if (this.rolType.ROLE_USER === rol || inCall) {

      return this.getCalendarOfUserInPlanningSection(calendarCommon);
    }
    if (this.rolType.ROLE_SUPERADMIN === rol || this.rolType.ROLE_ADMIN === rol || this.rolType.ROLE_BDC === rol) {
      return this.getCalendarOfUserWeekMode(calendarCommon);
    }
  }

  mapLeadinEvents(data: any): any {

    const dataMapped = data.map((leadinEvent: any) => {
      let title = leadinEvent.text || this.translateService.trans(`pages.leads.${leadinEvent.type}`);
      if (leadinEvent.isOutBusinessHours) {
        title = `${title}`;
      }
      return {
        id: leadinEvent.id,
        title,
        start: moment.unix(leadinEvent.dateFrom / 1000).toDate(),
        end: moment.unix(leadinEvent.dateTo / 1000).toDate(),
        resourceId: leadinEvent.userId,
        textColor: leadinEvent.textColor,
        backgroundColor: leadinEvent.backgroundColor,
        borderColor: leadinEvent.backgroundColor,
        eventOverlap: false,
        extendedProps: {
          type: leadinEvent.type,
          leadId: leadinEvent.leadId,
          isOutBusinessHours: leadinEvent.isOutBusinessHours,
          userRoleType: leadinEvent.userRoleType,
        }
      };
    });

    return dataMapped;

  }

  private getCalendarOfUserInPlanningSection(calendarBasic: FullCalendarComponent): FullCalendarComponent {
    const calendar = calendarBasic;
    calendar.defaultView = 'timeGridWeek';
    calendar.header = {
      left: 'customPrev, customNext, today',
      center: 'title',
      right: 'timeGridDay,timeGridWeek'
    };
    calendar.height = 'parent';
    return calendar;
  }

  private getCalendarOfUserWeekMode(calendarBasic: FullCalendarComponent): FullCalendarComponent {
    const calendar = calendarBasic;
    calendar.defaultView = 'resourceTimeGridWeek';
    calendar.header = {
      left: 'customPrev, customNext, today',
      center: 'title',
      right: 'resourceTimeGridDay,resourceTimeGridWeek'
    };
    calendar.height = 'parent';

    this.buildCalendarEvent(calendar);

    return calendar;
  }

  private getCalendarCommon(calendar: FullCalendarComponent): FullCalendarComponent {
    calendar.minTime = '07:00:00';
    calendar.timeGridEventMinHeight = 30;
    calendar.slotDuration = '00:05:00';
    calendar.eventLimit = true;
    calendar.schedulerLicenseKey = 'GPL-My-Project-Is-Open-Source';
    calendar.locales = allLocales;
    calendar.locale = this.translateService.getLanguage();
    calendar.height = 400;
    calendar.droppable = true;
    calendar.nowIndicator = true;
    calendar.scrollTime = moment().add(-15, 'minutes').format('HH:mm:ss');
    calendar.displayEventEnd = true;
    calendar.displayEventTime = true;

    this.buildCalendarEvent(calendar);

    return calendar;
  }

  private buildCalendarEvent(calendar) {
    if (this.authService.isTestAB()) {
      calendar.eventRender.subscribe(event => {
        event.el.title = `${event.event.title}`;

        if (event.event.extendedProps.userRoleType === this.rolType.ROLE_BDC) {

          event.el.getElementsByClassName('fc-title')[0].innerHTML = `
            <table style='border: 0;'>
              <thead style='border: 0;'>
                <th style='width: 13px; border: 0;'></th>
                <th style='width: 100%; border: 0;'></th>
              </thead>
              <tbody style='border: 0;'>
                <td style='width: 13px; border: 0;'><i class='fas fa-headset'></i></td>
                <td style='width: 100%; border: 0; text-overflow: ellipsis; white-space: normal; overflow: hidden;'>${event.event.title}</td>
              </tbody>
            </table>`;

          if (event.event.extendedProps.isOutBusinessHours) {
            event.el.getElementsByClassName('fc-title')[0].innerHTML = `
              <table style='border: 0;'>
              <thead style='border: 0;'>
                <th style='width: 13px; border: 0;'></th>
                <th style='width: 100%; border: 0;'></th>
              </thead>
              <tbody style='border: 0;'>
                <td style='width: 13px; border: 0;'><i class='fas fa-headset'></i> <i class='fas fa-moon'></i>
                <td style='width: 100%; border: 0; text-overflow: ellipsis; white-space: normal; overflow: hidden;'>${event.event.title}</td>
              </tbody>
            </table>`;
          }

          if (event.event.extendedProps.type === EventType.REMINDER) {
            event.el.style['background'] = '#FFD65D';
            event.el.style['border-color'] = '#FFD65D';
          }
          if (event.event.extendedProps.type === EventType.VISIT) {
            event.el.style['background'] = '#96BFE4';
            event.el.style['border-color'] = '#96BFE4';
          }
        } else {
          if (event.event.extendedProps.isOutBusinessHours) {
            event.el.getElementsByClassName('fc-title')[0].innerHTML = `<i class='fas fa-moon'></i> ${event.event.title}`;
          }
        }
      });
    }
  }
}
